import React from 'react';
import { Typography } from '@mui/material';
import BigNumber from 'bignumber.js';
import { makeStyles } from 'tss-react/mui';

import { globalTranslation, useTranslation } from 'modules/i18n';

interface Props {
  amount: BigNumber;
  unit: string;
}

export function AmountSpentCell({ amount, unit }: Props): JSX.Element {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(globalTranslation);

  return (
    <div className={classes.amount}>
      <Typography variant="subtitle3">
        {t(keys.units.tokenAmount, {
          amount: amount.decimalPlaces(2).toString(),
          token: unit,
        })}
      </Typography>
    </div>
  );
}

const useStyles = makeStyles()(() => ({
  amount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
}));
